<template>
    <div class="footer-acknowledgement">
        <slot>
            <p>
                Curtin University acknowledges Aboriginal and Torres Strait Islander people, the First Peoples of this place we call Australia,
                and recognise them for caring for Country for more than 60,000 years.
            </p>
            <p>
                We are honoured and grateful for the privilege to maintain campuses operating in Boorloo (Perth)
                and Karlkurla (Kalgoorlie) in Australia. We pay our respects to Elders past and present as
                Custodians and Owners of these lands. We recognise their deep knowledge and their cultural,
                spiritual and educational practices, and aspire to learn and teach in partnership with them.
            </p>
            <p>
                Curtin also acknowledges First Nations peoples connected with our global campuses. We are
                committed to working in partnership with all Custodians and Owners to strengthen and embed First
                Nations' voices and perspectives in our decision-making, now and into the future.
            </p>
        </slot>
    </div>
</template>

<style scoped>
    @reference 'tailwindcss';
    @reference "../styles/theme";

    .footer-acknowledgement {
        @apply text-sm pr-8 pb-8 lg:pr-16 lg:pb-0;
    }

    .footer-acknowledgement p {
        @apply mb-4 leading-[1.5] last:mb-0;
    }
</style>
